import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IVideoMediaDto } from 'src/app/core/dtos/interfaces/i-video-media-dto';
import { RestService } from './rest-service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class VideosService {
  static readonly ENTITY_IDENTIFIER: string = 'videos';
  private readonly BASE_MEDIA_ROUTE = `api/${VideosService.ENTITY_IDENTIFIER}`;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_MEDIA_ROUTE, ...args);

  constructor(private restService: RestService) {}

  getFiltered$(
    {
      currentPage,
      currentPageSize,
    }: { currentPage: number; currentPageSize: number } = {
      currentPage: 1,
      currentPageSize: 5,
    },
    {
      filters = {},
    }: {
      filters?: { [key: string]: unknown };
    } = {
      filters: {},
    },
  ): Observable<any> {
    const params = this.restService.buildParamsObjectWithPaging(
      filters,
      currentPage,
      currentPageSize,
    );
    return this.restService.get$<{
      results: IVideoMediaDto[];
      resultCount: number;
    }>(this.BUILD_HTTP_ROUTE(), {
      params,
    });
  }
}
